import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { adminLogin } from '@/lib/api';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please fill in all fields');
      return;
    }
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_email', res.data.email);
      toast.success('Welcome back!');
      navigate('/admin');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 className="font-heading text-3xl font-bold text-gray-900 uppercase" style={{ letterSpacing: '0.05em' }}>
            Prophet Malluc
          </h1>
          <p className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-body font-medium mt-3">
            Admin Access
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-sm font-body font-medium text-gray-700">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@prophetmalluc.com"
              className="mt-1 h-11 rounded-sm border-gray-200 font-body text-sm"
              data-testid="admin-login-email-input"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm font-body font-medium text-gray-700">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="mt-1 h-11 rounded-sm border-gray-200 font-body text-sm"
              data-testid="admin-login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-sm bg-[#1a2e4a] text-white font-body text-sm font-medium hover:bg-[#0f1b2d] transition-colors"
            data-testid="admin-login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        <p className="text-xs text-center text-gray-400 font-body mt-8">
          Secure admin portal. Authorized personnel only.
        </p>
      </div>
    </div>
  );
}
